<template>
    <a-modal
        centered
        :visible="visible"
        title="创建商标订单"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="840"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="order-create" :rules="rules">
            <a-row :gutter="48">
                <a-col :span="12">
                    <a-form-model-item label="客户ID" prop="member_id">
                        <a-select
                            class="spotlight"
                            show-search
                            :show-arrow="false"
                            :dropdownMatchSelectWidth="false"
                            placeholder="快速搜索姓名、手机号码..."
                            :filter-option="false"
                            @search="on_membersearch"
                            style="transition:0.2s width"
                            option-label-prop="name"
                            v-model="form.member_id"
                        >
                            <a-spin v-if="loading_member" slot="notFoundContent" size="small" />

                            <a-select-opt-group v-for="d in data_member" :key="d.id">
                                <span slot="label">
                                    <a-icon type="user" />
                                    {{ d.name }}
                                </span>
                                <a-select-option :value="d.id" :key="d.id" :name="d.name" :item="d">
                                    <div>
                                        <a-icon type="mobile" />
                                        {{ d.mobile }}
                                    </div>
                                </a-select-option>
                            </a-select-opt-group>
                        </a-select>
                    </a-form-model-item>

                    <a-form-model-item label="商标注册号" prop="apply_no">
                        <a-input-search v-model="form.apply_no" placeholder="输入商标注册号" @search="on_read_trademark">
                            <a-button slot="enterButton" type="primary">
                                读取数据
                            </a-button>
                        </a-input-search>
                    </a-form-model-item>

                    <a-row :gutter="18">
                        <a-col :span="12">
<!--                            <h2>买家客户</h2>-->
                            <a-form-model-item label="总金额" prop="amount">
                                <a-input v-model="form.amount"></a-input>
                            </a-form-model-item>

                            <a-form-model-item label="首付款" prop="amount_deposit">
                                <a-input v-model="form.amount_deposit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
<!--                            <h2>商标持有人</h2>-->
                            <a-form-model-item label="成本价格">
                                <a-input :value="data_trademark.price" disabled></a-input>
                            </a-form-model-item>

                            <a-form-model-item label="尾款">
                                <a-input v-model="form.amount - form.amount_deposit" disabled></a-input>
                            </a-form-model-item>
                        </a-col>
                    </a-row> </a-col
                ><a-col :span="12">
                    <a-form-model-item>
                        <a-checkbox v-model="form.is_include_notary">
                            是否包含公证
                        </a-checkbox>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-checkbox v-model="form.is_include_invoice">
                            是否包含发票
                        </a-checkbox>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-checkbox v-model="form.is_include_transfer">
                            是否包含转让费
                        </a-checkbox>
                    </a-form-model-item>
                    <a-form-model-item label="订单备注">
                        <a-textarea v-model="form.remark"></a-textarea>
                    </a-form-model-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        apply_no: null,
        member_id: null,
        amount: null,
        remark: null,
        amount_deposit_seller: null,
        amount_deposit: null,
        amount_service:null,
        is_include_invoice: false,
        is_include_license: false,
        is_include_notary: false,
        is_include_transfer: false,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            record: null,
            callback: null,
            mode: {
                default: "create",
            },
        },
        data() {
            return {
                submitting: false,
                loading_member: false,
                data_member: [],
                data_trademark: {},
                rules: {
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    apply_no: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_deposit_seller:[
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount_deposit:[
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ]
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
            // this.load_group();
            // this.load_role();
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    Object.keys(this.form).map((v) => {
                        if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                        }
                    });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_membersearch(v) {
                this.loading_member = true;
                this.$http
                    .get(`/member/accessible?type=plain&wd=${v}`)
                    .then((response) => {
                        if (response.success) {
                            this.data_member = response.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading_member = false;
                    });
            },
            on_submit() {
                this.$refs["order-create"].validate((valid) => {
                    if (valid) {
                        if (this.mode === "create") {
                            return this.on_create();
                        } else {
                            return this.on_edit();
                        }
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            on_create() {
                this.submitting = true;
                this.$http
                    .post("/order_trademark", this.form)
                    .then((res) => {
                        if (res.success) {
                            this.cancel();
                            this.$message.success(res.message);
                            if (this.callback) {
                                this.callback();
                            }
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            on_edit() {
                this.submitting = true;
                this.$http
                    .put("/order_trademark/user/" + this.record.id, this.form)
                    .then((res) => {
                        if (res.success) {
                            this.$message.success(res.message);
                            this.cancel();
                            this.$emit("load");
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            after_close() {
                this.$refs["order-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
            on_read_trademark() {
                let apply_no = this.form.apply_no;
                if (!apply_no) {
                    return false;
                }

                this.$http
                    .get("/trademark/" + apply_no)
                    .then((res) => {
                        if (res.success) {
                            this.data_trademark = res.data;
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
        },
    };
</script>
